export default __webpack_public_path__ + "static/media/photoprofil4.c3ece99f.png";